import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayKey' })
export class MapDeepObjects implements PipeTransform {
  transform(object: {}, key: string): unknown {
    if (key.includes('.')) {
      return key.split('.').reduce((prev, curr) => {
        return prev ? prev[curr] : null;
      }, object || self);
    }
    return object[key];
  }
}

@Pipe({ name: 'displayKeyUpdate', pure: false })
export class MapDeepObjectChangeDiff extends MapDeepObjects {}
